import { useState } from "react";
import { useHistory } from "react-router";
import { useValue } from "../../../providers/ValueContext";
import { useEmployees } from "../../../providers/EmployeesContext";
import EmployeesCards from "../../../Components/ComponentsIndustry/EmployeesCards";
import CountFooter from "../../../Components/ComponentsIndustry/CountFooter";
import FooterButton from "../../../Components/ComponentsIndustry/FooterButton";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  TitleSection,
  ImgTitle,
  BackButton,
} from "./style";
import { useUser } from "../../../providers/UserContext";

const Employees = () => {

  const {
    diretorGeral,
    gestorAdministrativo,
    gestorFinanceiro,
    encarregadoContabilidade,
    encarregadoRH,
    encarregadoTesouraria,
    compras,
    gestorLogistica,
    gestaoProducao,
    encarregadoLogistica,
    operadores,
    controleQualidade,
    gestorComercial,
    vendedor,
  } = useEmployees();

  const { user, rodada, DoAForcedGet, industry, jogo, isNeededSetupIndustry } = useUser()

  const history = useHistory();

  const { salary, setSalary, entranceValue } = useValue();

  let [total, setTotal] = useState(0);

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  const handlePay = () => {
    setSalary(salary + total);

    const data = industry

    data.funcCompras = compras.amount;
    data.funcControleQualidade = controleQualidade.amount;
    data.funcDiretorGeral = diretorGeral.amount;
    data.funcEncContabilidade = encarregadoContabilidade.amount;
    data.funcEncLogistica = encarregadoLogistica.amount;
    data.funcEncRH = encarregadoRH.amount;
    data.funcEncTesouraria = encarregadoTesouraria.amount;
    data.funcGestorAdm = gestorAdministrativo.amount;
    data.funcGestorComercial = gestorComercial.amount;
    data.funcGestorFin = gestorFinanceiro.amount;
    data.funcGestorLogistica = gestorLogistica.amount;
    data.funcGestorProducao = gestaoProducao.amount;
    data.funcOperador = operadores.amount;
    data.funcVendedor = vendedor.amount;

    if (entranceValue >= total) {
      api.post("/api/industria/cadastrar", data)
        .then(response => {
          DoAForcedGet()
        })
        .catch(error => console.log(error))
      setTotal(0);
      history.push("/mapMenu")
    } else {
      alert("Saldo Insuficiente")
    }

    if (!rodada) {
      const data1 = {
        "codJogo": jogo?.jogo,
        "numero": "1",
        "industria": {
          "industria": industry?.industria
        },
        "usuarioInicio": {
          "usuario": user?.usuario
        }
      }

      api.post("/api/rodada/iniciarNova", data1)
        .then(response => {
          DoAForcedGet()
        })
        .catch(error => console.log(error))
    }

    setTotal(0);
  };

  return (
    <Container>
      <SizeContainer>
        <Title>Monte sua Fábrica</Title>
        <TitleSection>
          <ImgTitle />
          Funcionários
          <BackButton onClick={() => history.push(!isNeededSetupIndustry ? "/mapMenu" : "/machinery")} />
        </TitleSection>
        <EmployeesCards total={total} setTotal={setTotal} />
        <CountFooter total={total} />
        <FooterButton text="Confirmar" onHandle={handlePay} />
      </SizeContainer>
    </Container>
  );
};
export default Employees;
